import { render, staticRenderFns } from "./SailListPage.vue?vue&type=template&id=ba15b516&scoped=true&"
import script from "./SailListPage.vue?vue&type=script&lang=js&"
export * from "./SailListPage.vue?vue&type=script&lang=js&"
import style0 from "./SailListPage.vue?vue&type=style&index=0&id=ba15b516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba15b516",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba15b516')) {
      api.createRecord('ba15b516', component.options)
    } else {
      api.reload('ba15b516', component.options)
    }
    module.hot.accept("./SailListPage.vue?vue&type=template&id=ba15b516&scoped=true&", function () {
      api.rerender('ba15b516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/SailListPage.vue"
export default component.exports